import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const AffichageResponsive = ({ composantDesktop, composantMobile, pointDeRupture }) => {
    const valeursPointsDeRupture = new Map([
        ['sm', 576],
        ['md', 768],
        ['lg', 992],
        ['xl', 1248],
    ]);

    const doitAfficherEnDesktop = () =>
        window.innerWidth > valeursPointsDeRupture.get(pointDeRupture);

    const [estDesktop, setEstDesktop] = useState(doitAfficherEnDesktop());

    const mettreAJourAffichage = () => {
        setEstDesktop(doitAfficherEnDesktop());
    };

    useEffect(() => {
        window.addEventListener('resize', mettreAJourAffichage);
        return () => window.removeEventListener('resize', mettreAJourAffichage);
    });

    return estDesktop ? composantDesktop : composantMobile;
};

AffichageResponsive.propTypes = {
    composantDesktop: PropTypes.element.isRequired,
    composantMobile: PropTypes.element.isRequired,
    pointDeRupture: PropTypes.string.isRequired,
};

export default AffichageResponsive;
